import { bffApiService } from 'config/service';
import { PayloadShareFreightWithTrucker } from './types';

export const postShareFreightWithTrucker = ({
  encodedFreightId,
  truckersUuid,
}: PayloadShareFreightWithTrucker): Promise<void> =>
  bffApiService.post(`/freights/${encodedFreightId}/share`, { truckers: truckersUuid });
